import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

// ─── Correspondance code catégorie juridique INSEE → libellé ─────────────────
const FORMES_JURIDIQUES = {
  '1000': 'EI', '2110': 'SARL', '2120': 'SARL', '2210': 'SA',
  '2220': 'SA', '2310': 'SA', '2320': 'SA', '2385': 'SA',
  '5191': 'SARL', '5192': 'SARL', '5193': 'SARL', '5202': 'SARL',
  '5306': 'SASU', '5307': 'SAS', '5308': 'SAS', '5309': 'SAS',
  '5310': 'SAS', '5370': 'SNC', '5410': 'SCS', '5485': 'EURL',
  '5498': 'EURL', '5499': 'SARL', '6317': 'Association',
  '9220': 'Association', '9221': 'Association',
};

function formatPhone(val) {
  if (!val) return val;
  const digits = val.replace(/\D/g, '');
  if (digits.length <= 2) return digits;
  let formatted = '';
  for (let i = 0; i < digits.length && i < 10; i += 2) {
    if (formatted) formatted += ' ';
    formatted += digits.substring(i, Math.min(i + 2, digits.length));
  }
  return formatted;
}

function getFormeJuridique(code) {
  if (!code) return '';
  if (FORMES_JURIDIQUES[code]) return FORMES_JURIDIQUES[code];
  // Correspondances génériques par préfixe
  const prefix = String(code).substring(0, 2);
  if (prefix === '53') return 'SAS';
  if (prefix === '54') return 'SCS';
  if (prefix === '21' || prefix === '51') return 'SARL';
  if (prefix === '22' || prefix === '23') return 'SA';
  if (prefix === '10') return 'EI';
  if (prefix === '92' || prefix === '63') return 'Association';
  return 'Autre';
}

// ─── Mapping NAF/APE → libellé activité ──────────────────────────────────────
// L'API renvoie directement le libellé NAF, on l'utilise tel quel

// ─── Styles de la modale ──────────────────────────────────────────────────────
const S = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.55)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1000,
  },
  dialog: {
    background: '#fff', borderRadius: '8px',
    width: '880px', maxWidth: '95vw', maxHeight: '90vh',
    display: 'flex', flexDirection: 'column',
    boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
  },
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '1.25rem 1.5rem', borderBottom: '2px solid #ecf0f1',
    background: '#2c3e50', borderRadius: '8px 8px 0 0',
  },
  headerTitle: { color: '#fff', fontSize: '1.2rem', fontWeight: 600, margin: 0 },
  closeBtn: {
    background: 'none', border: 'none', color: '#fff',
    fontSize: '1.5rem', cursor: 'pointer', lineHeight: 1,
  },
  body: { padding: '1.5rem', overflowY: 'auto', flex: 1 },
  footer: {
    padding: '1rem 1.5rem', borderTop: '1px solid #ecf0f1',
    display: 'flex', justifyContent: 'flex-end', gap: '0.75rem',
    background: '#f8f9fa', borderRadius: '0 0 8px 8px',
  },
  grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem 1.5rem' },
  grid3: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem 1.5rem' },
  sectionTitle: {
    fontSize: '0.8rem', fontWeight: 700, textTransform: 'uppercase',
    letterSpacing: '0.08em', color: '#7f8c8d',
    margin: '1.25rem 0 0.75rem', paddingBottom: '0.35rem',
    borderBottom: '1px solid #ecf0f1',
  },
  label: {
    display: 'block', marginBottom: '0.3rem',
    fontSize: '0.875rem', fontWeight: 500, color: '#2c3e50',
  },
  required: { color: '#e74c3c', marginLeft: '2px' },
  input: {
    width: '100%', padding: '0.6rem 0.75rem',
    border: '1px solid #ddd', borderRadius: '4px',
    fontSize: '0.9rem', boxSizing: 'border-box',
  },
  inputFilled: {
    width: '100%', padding: '0.6rem 0.75rem',
    border: '1px solid #27ae60', borderRadius: '4px',
    fontSize: '0.9rem', boxSizing: 'border-box',
    background: '#f0fff4',
  },
  select: {
    width: '100%', padding: '0.6rem 0.75rem',
    border: '1px solid #ddd', borderRadius: '4px',
    fontSize: '0.9rem', background: '#fff', boxSizing: 'border-box',
  },
  textarea: {
    width: '100%', padding: '0.6rem 0.75rem',
    border: '1px solid #ddd', borderRadius: '4px',
    fontSize: '0.9rem', resize: 'vertical', minHeight: '70px', boxSizing: 'border-box',
  },
  textareaFilled: {
    width: '100%', padding: '0.6rem 0.75rem',
    border: '1px solid #27ae60', borderRadius: '4px',
    fontSize: '0.9rem', resize: 'vertical', minHeight: '70px', boxSizing: 'border-box',
    background: '#f0fff4',
  },
  errorBanner: {
    background: '#f8d7da', color: '#721c24',
    padding: '0.75rem 1rem', borderRadius: '4px',
    marginBottom: '1rem', fontSize: '0.9rem',
    borderLeft: '4px solid #e74c3c',
  },
  siretBanner: {
    display: 'flex', alignItems: 'center', gap: '0.5rem',
    padding: '0.6rem 1rem', borderRadius: '4px',
    marginBottom: '0.75rem', fontSize: '0.875rem',
  },
  siretRow: { display: 'flex', gap: '0.5rem', alignItems: 'flex-end' },
  siretInputWrap: { flex: 1 },
  lookupBtn: {
    padding: '0.6rem 1rem', background: '#3498db', color: '#fff',
    border: 'none', borderRadius: '4px', cursor: 'pointer',
    fontSize: '0.875rem', fontWeight: 600, whiteSpace: 'nowrap',
    height: '38px', display: 'flex', alignItems: 'center', gap: '0.35rem',
  },
  lookupBtnDisabled: {
    padding: '0.6rem 1rem', background: '#95a5a6', color: '#fff',
    border: 'none', borderRadius: '4px', cursor: 'not-allowed',
    fontSize: '0.875rem', fontWeight: 600, whiteSpace: 'nowrap',
    height: '38px', display: 'flex', alignItems: 'center', gap: '0.35rem',
  },
  spinner: {
    display: 'inline-block', width: '14px', height: '14px',
    border: '2px solid rgba(255,255,255,0.4)',
    borderTopColor: '#fff', borderRadius: '50%',
    animation: 'spin 0.7s linear infinite',
  },
};

// ─── Champ de formulaire ──────────────────────────────────────────────────────
function Field({ label, required, children }) {
  return (
    <div>
      <label style={S.label}>
        {label}
        {required && <span style={S.required}>*</span>}
      </label>
      {children}
    </div>
  );
}

// ─── Valeurs initiales ────────────────────────────────────────────────────────
const EMPTY_FORM = {
  nom: '', adresse: '', code_postal: '',
  ville: '', forme_juridique: '', siret: '', representant: '',
  titre_representant: '', mail: '', telephone: '', activite_principale: '',
  date_creation: '', iban_id: '', statut: 'Actif',
};

// ─── Utilitaires INSEE ────────────────────────────────────────────────────────
function formatDateCreation(dateStr) {
  // dateStr peut être "20150115" ou "2015-01-15"
  if (!dateStr) return '';
  const s = String(dateStr).replace(/-/g, '');
  if (s.length === 8) {
    return `${s.substring(0, 4)}-${s.substring(4, 6)}-${s.substring(6, 8)}`;
  }
  return dateStr;
}

function capitalizeWords(str) {
  if (!str) return '';
  return str.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
}

// ─── Composant principal ──────────────────────────────────────────────────────
function SoustraitantList() {
  const [soustraitants, setSoustraitants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');

  // Modale
  const [showModal, setShowModal]       = useState(false);
  const [form, setForm]                 = useState(EMPTY_FORM);
  const [ibanList, setIbanList]         = useState([]);
  const [saving, setSaving]             = useState(false);
  const [formError, setFormError]       = useState('');

  // SIRET lookup
  const [siretLoading, setSiretLoading] = useState(false);
  const [siretStatus, setSiretStatus]   = useState(null); // null | 'ok' | 'error'
  const [siretMsg, setSiretMsg]         = useState('');
  const [autoFilled, setAutoFilled]     = useState(false); // indique si les champs ont été remplis
  const debounceRef = useRef(null);

  // Types d'activité
  const [typesActivite, setTypesActivite] = useState([]);
  const [selectedActivites, setSelectedActivites] = useState([]); // [{type_activite_id, principal}]
  const [activiteSearch, setActiviteSearch] = useState('');

  useEffect(() => { fetchSoustraitants(); fetchTypesActivite(); }, []);

  const fetchSoustraitants = async () => {
    try {
      const r = await axios.get('/api/soustraitants');
      setSoustraitants(r.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const fetchTypesActivite = async () => {
    try {
      const r = await axios.get('/api/types-activite');
      setTypesActivite(r.data);
    } catch(e) { console.error(e); }
  };

  const fetchIbans = async () => {
    try {
      const r = await axios.get('/api/ibans');
      setIbanList(r.data);
    } catch (e) {
      console.warn('Route /api/ibans non disponible:', e.message);
      setIbanList([]);
    }
  };

  const openModal = () => {
    setForm(EMPTY_FORM);
    setFormError('');
    setSiretStatus(null);
    setSiretMsg('');
    setAutoFilled(false);
    setSelectedActivites([]);
    fetchIbans();
    setShowModal(true);
  };

  const closeModal = () => { if (!saving) setShowModal(false); };

  // ── Recherche SIRET via API Recherche Entreprises (api.gouv.fr) ─────────────
  const lookupSiret = async (siret) => {
    const clean = String(siret).replace(/\s/g, '');
    if (clean.length !== 14) {
      setSiretStatus('error');
      setSiretMsg('Le SIRET doit comporter exactement 14 chiffres.');
      return;
    }

    setSiretLoading(true);
    setSiretStatus(null);
    setSiretMsg('');

    try {
      // API Recherche Entreprises — publique, gratuite, sans clé
      const url = `https://recherche-entreprises.api.gouv.fr/search?q=${clean}&page=1&per_page=1`;
      const response = await fetch(url);

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data = await response.json();

      if (!data.results || data.results.length === 0) {
        setSiretStatus('error');
        setSiretMsg('Aucune entreprise trouvée pour ce SIRET.');
        return;
      }

      // Chercher l'établissement correspondant au SIRET exact
      const entreprise = data.results[0];
      let etablissement = null;

      // L'API retourne les établissements dans matching_etablissements
      if (entreprise.matching_etablissements && entreprise.matching_etablissements.length > 0) {
        etablissement = entreprise.matching_etablissements.find(
          e => e.siret === clean
        ) || entreprise.matching_etablissements[0];
      }

      // Extraction des données de l'entreprise (niveau SIREN)
      const nom = entreprise.nom_complet
        || entreprise.nom_raison_sociale
        || capitalizeWords(entreprise.nom_complet)
        || '';

      const formeCode = entreprise.nature_juridique || '';
      const forme = getFormeJuridique(formeCode);

      // Date de création : date de création de l'établissement ou de l'unité légale
      const dateCrea = etablissement?.date_creation
        || entreprise.date_creation
        || '';

      // Activité principale (libellé NAF)
      const activite = etablissement?.libelle_activite_principale
        || entreprise.libelle_activite_principale
        || entreprise.activite_principale
        || '';

      // Adresse
      let adresse = '';
      let code_postal = '';
      let ville = '';

      if (etablissement) {
        const num    = etablissement.numero_voie || '';
        const type   = etablissement.type_voie   || '';
        const libelle = etablissement.libelle_voie || '';
        const compl  = etablissement.complement_adresse || '';

        adresse = [compl, `${num} ${type} ${libelle}`]
          .filter(Boolean).map(s => s.trim()).filter(Boolean).join(', ');

        code_postal = etablissement.code_postal || '';
        ville = capitalizeWords(etablissement.libelle_commune || '');
      }

      // Remplissage du formulaire — on ne remplace PAS la codification ni les champs IBAN/statut
      setForm(prev => ({
        ...prev,
        nom:                nom || prev.nom,
        adresse:            adresse || prev.adresse,
        code_postal:        code_postal || prev.code_postal,
        ville:              ville || prev.ville,
        forme_juridique:    forme || prev.forme_juridique,
        activite_principale: activite || prev.activite_principale,
        date_creation:      formatDateCreation(dateCrea) || prev.date_creation,
        // On garde siret tel quel (déjà rempli)
      }));

      setAutoFilled(true);
      setSiretStatus('ok');
      setSiretMsg(`✓ ${nom} — données pré-remplies depuis le Registre National des Entreprises`);
    } catch (err) {
      console.error('Erreur lookup SIRET:', err);
      setSiretStatus('error');
      setSiretMsg('Impossible de contacter l\'API entreprises. Vérifiez votre connexion ou renseignez les champs manuellement.');
    } finally {
      setSiretLoading(false);
    }
  };

  // ── Gestion des changements de champs ──────────────────────────────────────
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));

    // Déclenchement auto dès 14 chiffres dans le champ SIRET
    if (name === 'siret') {
      setAutoFilled(false);
      setSiretStatus(null);
      setSiretMsg('');
      const clean = value.replace(/\s/g, '');
      if (clean.length === 14) {
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => lookupSiret(clean), 400);
      }
    }
  };

  // ── Soumission ─────────────────────────────────────────────────────────────
  const handleSubmit = async () => {
    setFormError('');
    if (!form.nom.trim()) { setFormError('Le nom est obligatoire.'); return; }

    setSaving(true);
    try {
      const payload = {
        ...form,
        iban_id:       form.iban_id ? parseInt(form.iban_id, 10) : null,
        date_creation: form.date_creation || null,
        activites:     selectedActivites,
      };
      await axios.post('/api/soustraitants', payload);
      await fetchSoustraitants();
      setShowModal(false);
    } catch (err) {
      setFormError(err.response?.data?.details || err.response?.data?.error || 'Erreur lors de la création.');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (codification) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce sous-traitant ?')) {
      try {
        await axios.delete(`/api/soustraitants/${codification}`);
        fetchSoustraitants();
      } catch { alert('Erreur lors de la suppression'); }
    }
  };

  const filteredSoustraitants = soustraitants.filter(st => {
    if (filter === 'actif')   return st.statut === 'Actif';
    if (filter === 'inactif') return st.statut === 'Inactif';
    if (filter === 'perime')  return !st.conforme;
    return true;
  }).filter(st => {
    if (!search.trim()) return true;
    const s = search.toLowerCase();
    return (st.nom || '').toLowerCase().includes(s) ||
      (st.mail || '').toLowerCase().includes(s) ||
      (st.ville || '').toLowerCase().includes(s) ||
      (st.activite_principale_nom || st.activite_principale || '').toLowerCase().includes(s) ||
      (st.codification || '').toLowerCase().includes(s);
  });

  // Style conditionnel selon remplissage auto
  const inputStyle  = (field) => autoFilled && form[field] ? S.inputFilled  : S.input;
  const taStyle     = (field) => autoFilled && form[field] ? S.textareaFilled : S.textarea;

  if (loading) return <div className="loading">Chargement...</div>;

  return (
    <div>
      {/* ── Animation spinner ── */}
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>

      {/* ── Liste ── */}
      <div className="card">
        <div className="card-header">
          <h1 className="card-title">Sous-traitants</h1>
          <input
            type="text"
            placeholder="Rechercher..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ flex: '1', maxWidth: '300px', margin: '0 1rem', padding: '0.5rem 0.75rem', border: '1px solid #ddd', borderRadius: '4px', fontSize: '0.9rem' }}
          />
          <button className="btn btn-primary" onClick={openModal}>
            + Nouveau sous-traitant
          </button>
        </div>

        <div style={{ marginBottom: '1rem', display: 'flex', gap: '0.5rem' }}>
          {[
            { key: 'all',    label: 'Tous' },
            { key: 'actif',  label: 'Actifs' },
            { key: 'inactif',label: 'Inactifs' },
            { key: 'perime', label: 'Documents périmés' },
          ].map(f => (
            <button key={f.key}
              className={`btn ${filter === f.key ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => setFilter(f.key)}>
              {f.label}
            </button>
          ))}
        </div>

        <table>
          <thead>
            <tr>
              <th>Nom</th><th>Contact</th><th>Activité</th><th>Ville</th>
              <th>Statut</th><th>Documents</th><th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredSoustraitants.length === 0 ? (
              <tr><td colSpan="7" style={{ textAlign: 'center', padding: '2rem' }}>
                Aucun sous-traitant trouvé
              </td></tr>
            ) : filteredSoustraitants.map(st => (
              <tr key={st.codification}>
                <td><strong>{st.nom}</strong></td>
                <td>{st.mail || '-'}</td>
                <td style={{ fontSize: '0.85rem' }}>{st.activite_principale_nom || st.activite_principale || '—'}</td>
                <td>{st.ville || '-'}</td>
                <td>
                  <button
                    onClick={async (e) => {
                      e.stopPropagation();
                      const newStatut = st.statut === 'Actif' ? 'Inactif' : 'Actif';
                      try {
                        await axios.put(`/api/soustraitants/${st.codification}`, { statut: newStatut });
                        fetchSoustraitants();
                      } catch (err) {
                        alert('Erreur lors du changement de statut');
                      }
                    }}
                    className={`badge ${st.statut === 'Actif' ? 'badge-success' : 'badge-warning'}`}
                    style={{ cursor: 'pointer', border: 'none', display: 'inline-flex', alignItems: 'center', gap: '0.3rem' }}
                    title={`Cliquer pour passer en ${st.statut === 'Actif' ? 'Inactif' : 'Actif'}`}
                  >
                    {st.statut === 'Actif' ? '🟢' : '🔴'} {st.statut}
                  </button>
                </td>
                <td>
                  <span className={`badge ${st.conforme ? 'badge-success' : 'badge-danger'}`}>
                    {st.conforme ? 'A Jour' : 'Non conforme'}
                  </span>
                </td>
                <td>
                  <div className="actions">
                    <Link to={`/soustraitants/${st.codification}`} className="btn btn-primary">Détails</Link>
                    <button onClick={() => handleDelete(st.codification)} className="btn btn-danger">Supprimer</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ── Modale création ── */}
      {showModal && (
        <div style={S.overlay} onClick={closeModal}>
          <div style={S.dialog} onClick={e => e.stopPropagation()}>

            {/* En-tête */}
            <div style={S.header}>
              <h2 style={S.headerTitle}>Nouveau sous-traitant</h2>
              <button style={S.closeBtn} onClick={closeModal} title="Fermer">×</button>
            </div>

            {/* Corps */}
            <div style={S.body}>
              {formError && <div style={S.errorBanner}>{formError}</div>}

              {/* ── SIRET en premier — déclencheur de l'auto-remplissage ── */}
              <div style={S.sectionTitle}>Recherche automatique par SIRET</div>

              <div style={S.siretRow}>
                <div style={S.siretInputWrap}>
                  <Field label="SIRET" required>
                    <input
                      style={siretStatus === 'ok' ? S.inputFilled : S.input}
                      name="siret"
                      value={form.siret}
                      onChange={handleChange}
                      placeholder="Saisir les 14 chiffres du SIRET…"
                      maxLength={14}
                    />
                  </Field>
                </div>
                <button
                  style={siretLoading ? S.lookupBtnDisabled : S.lookupBtn}
                  onClick={() => lookupSiret(form.siret)}
                  disabled={siretLoading}
                  title="Rechercher les informations de l'entreprise"
                >
                  {siretLoading
                    ? <><span style={S.spinner} /> Recherche…</>
                    : <>🔍 Rechercher</>
                  }
                </button>
              </div>

              {/* Bandeau de statut SIRET */}
              {siretMsg && (
                <div style={{
                  ...S.siretBanner,
                  background: siretStatus === 'ok' ? '#d4edda' : '#fff3cd',
                  color:      siretStatus === 'ok' ? '#155724' : '#856404',
                  border:     `1px solid ${siretStatus === 'ok' ? '#c3e6cb' : '#ffeeba'}`,
                }}>
                  {siretMsg}
                </div>
              )}

              {autoFilled && (
                <div style={{
                  fontSize: '0.78rem', color: '#27ae60',
                  marginBottom: '0.75rem',
                  display: 'flex', alignItems: 'center', gap: '0.4rem',
                }}>
                  <span>🟢</span>
                  <span>Les champs surlignés en vert ont été remplis automatiquement — vous pouvez les modifier si nécessaire.</span>
                </div>
              )}

              {/* ── Identification ── */}
              <div style={S.sectionTitle}>Identification</div>
              <Field label="Nom / Raison sociale" required>
                <input style={inputStyle('nom')} name="nom"
                  value={form.nom} onChange={handleChange}
                  placeholder="Raison sociale" />
              </Field>

              {/* ── Coordonnées ── */}
              <div style={S.sectionTitle}>Coordonnées</div>
              <div style={{ marginBottom: '1rem' }}>
                <Field label="Adresse">
                  <textarea style={taStyle('adresse')} name="adresse"
                    value={form.adresse} onChange={handleChange}
                    placeholder="Numéro, rue…" rows={2} />
                </Field>
              </div>
              <div style={S.grid3}>
                <Field label="Code postal">
                  <input style={inputStyle('code_postal')} name="code_postal"
                    value={form.code_postal} onChange={handleChange}
                    placeholder="75000" maxLength={10} />
                </Field>
                <Field label="Ville">
                  <input style={inputStyle('ville')} name="ville"
                    value={form.ville} onChange={handleChange}
                    placeholder="Paris" />
                </Field>
                <Field label="Mail">
                  <input style={S.input} type="email" name="mail"
                    value={form.mail} onChange={handleChange}
                    placeholder="contact@exemple.fr" />
                </Field>
              </div>
              <div style={S.grid2}>
                <Field label="Téléphone">
                  <input style={S.input} type="tel" name="telephone"
                    value={form.telephone}
                    onChange={e => {
                      const formatted = formatPhone(e.target.value);
                      setForm(prev => ({ ...prev, telephone: formatted }));
                    }}
                    placeholder="01 23 45 67 89" maxLength={14} />
                </Field>
              </div>

              {/* ── Informations juridiques ── */}
              <div style={S.sectionTitle}>Informations juridiques</div>
              <div style={S.grid3}>
                <Field label="Forme juridique">
                  <select
                    style={autoFilled && form.forme_juridique
                      ? { ...S.select, border: '1px solid #27ae60', background: '#f0fff4' }
                      : S.select
                    }
                    name="forme_juridique" value={form.forme_juridique} onChange={handleChange}>
                    <option value="">— Sélectionner —</option>
                    <option value="SARL">SARL</option>
                    <option value="SAS">SAS</option>
                    <option value="SA">SA</option>
                    <option value="SASU">SASU</option>
                    <option value="EURL">EURL</option>
                    <option value="SNC">SNC</option>
                    <option value="EI">EI / Auto-entrepreneur</option>
                    <option value="Association">Association</option>
                    <option value="Autre">Autre</option>
                  </select>
                </Field>
                <Field label="Date de création">
                  <input style={inputStyle('date_creation')} type="date"
                    name="date_creation" value={form.date_creation} onChange={handleChange} />
                </Field>
                <Field label="Statut">
                  <select style={S.select} name="statut" value={form.statut} onChange={handleChange}>
                    <option value="Actif">Actif</option>
                    <option value="Inactif">Inactif</option>
                  </select>
                </Field>
              </div>

              {/* ── Représentant ── */}
              <div style={S.sectionTitle}>Représentant</div>
              <div style={S.grid2}>
                <Field label="Nom du représentant">
                  <input style={S.input} name="representant"
                    value={form.representant} onChange={handleChange}
                    placeholder="Prénom Nom" />
                </Field>
                <Field label="Titre du représentant">
                  <input style={S.input} name="titre_representant"
                    value={form.titre_representant} onChange={handleChange}
                    placeholder="Ex : Gérant, Directeur…" />
                </Field>
              </div>

              {/* ── Activités ── */}
              <div style={S.sectionTitle}>Activités</div>
              {typesActivite.length > 0 ? (
                <div style={{ marginBottom: '1rem' }}>
                  <input
                    type="text"
                    placeholder="Rechercher une activité..."
                    value={activiteSearch}
                    onChange={e => setActiviteSearch(e.target.value)}
                    style={{ ...S.input, marginBottom: '0.5rem' }}
                  />
                <div style={{ maxHeight: '280px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '4px', padding: '0.25rem' }}>
                  {(() => {
                    const filtered = typesActivite.filter(ta => !activiteSearch.trim() || ta.nom.toLowerCase().includes(activiteSearch.toLowerCase()));
                    const cats = [...new Set(filtered.map(ta => ta.categorie || 'AUTRES'))].sort();
                    return cats.map(cat => (
                      <div key={cat}>
                        <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#7f8c8d', textTransform: 'uppercase',
                          padding: '0.4rem 0.5rem 0.2rem', borderBottom: '1px solid #ecf0f1', letterSpacing: '0.04em',
                          background: '#fafafa', position: 'sticky', top: 0, zIndex: 1 }}>{cat}</div>
                        {filtered.filter(ta => (ta.categorie || 'AUTRES') === cat).map(ta => {
                          const isSelected = selectedActivites.some(a => a.type_activite_id === ta.id);
                          const isPrincipal = selectedActivites.find(a => a.type_activite_id === ta.id)?.principal || false;
                          return (
                            <div key={ta.id} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.3rem 0.5rem',
                              background: isSelected ? '#f0fff4' : 'transparent', borderRadius: '4px', marginBottom: '1px' }}>
                              <input type="checkbox" checked={isSelected}
                                onChange={() => {
                                  if (isSelected) {
                                    setSelectedActivites(prev => prev.filter(a => a.type_activite_id !== ta.id));
                                  } else {
                                    setSelectedActivites(prev => [...prev, { type_activite_id: ta.id, principal: prev.length === 0 }]);
                                  }
                                }} />
                              <span style={{ flex: 1, fontSize: '0.85rem' }}>{ta.nom}</span>
                              {isSelected && (
                                <label style={{ fontSize: '0.75rem', color: isPrincipal ? '#27ae60' : '#999', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.2rem' }}>
                                  <input type="radio" name="activite_principale_radio" checked={isPrincipal}
                                    onChange={() => {
                                      setSelectedActivites(prev => prev.map(a => ({ ...a, principal: a.type_activite_id === ta.id })));
                                    }} />
                                  Principal
                                </label>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    ));
                  })()}
                </div>
                </div>
              ) : (
                <p style={{ fontSize: '0.85rem', color: '#999', fontStyle: 'italic' }}>
                  Aucun type d'activité défini. Ajoutez-en dans Administration &gt; Activités.
                </p>
              )}

              {/* ── Coordonnées bancaires ── */}
              <div style={S.sectionTitle}>Coordonnées bancaires</div>
              <div style={S.grid2}>
                <Field label="IBAN (depuis la table IBAN)">
                  <select style={S.select} name="iban_id" value={form.iban_id} onChange={handleChange}>
                    <option value="">— Aucun IBAN —</option>
                    {ibanList.length === 0
                      ? <option disabled>Aucun IBAN enregistré</option>
                      : ibanList.map(iban => (
                          <option key={iban.id} value={iban.id}>
                            {iban.iban}{iban.bic ? ` · ${iban.bic}` : ''}{iban.principal ? ' ★' : ''}
                          </option>
                        ))
                    }
                  </select>
                </Field>
              </div>
            </div>

            {/* Pied de page */}
            <div style={S.footer}>
              <button className="btn btn-secondary" onClick={closeModal} disabled={saving}>
                Annuler
              </button>
              <button className="btn btn-primary" onClick={handleSubmit} disabled={saving}>
                {saving ? 'Enregistrement…' : 'Créer le sous-traitant'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SoustraitantList;
